module.exports = __webpack_public_path__ + "5a43de57446e56d29d5750f4307654ab.svg";